import CDN_BASE from './cdn';

// Header shown when a spot (or a truck) has no photo of its own: a skyline
// illustration of the site's own city. These used to be one Seattle skyline
// (`locationheader.png`) everywhere, which put the Space Needle above Portland
// and Austin addresses. Origin-served from public/static/photos, which nginx
// caches as immutable, so a redrawn illustration needs a new filename. Any
// other city falls back to the city-neutral default hero.
const LOCATION_DEFAULT_PHOTOS = {
  Austin: '/static/photos/austin-location-default-1600.webp',
  Portland: '/static/photos/portland-location-default-1600.webp',
  Seattle: '/static/photos/seattle-location-default-1600.webp',
};
const FALLBACK_PHOTO = `${CDN_BASE}/photos/home-hero.webp`;

export default function locationDefaultPhoto(cityName) {
  return LOCATION_DEFAULT_PHOTOS[cityName] || FALLBACK_PHOTO;
}
